import React from 'react';
import { HomePage } from './pages/HomePage';
export function App() {
  return <div className="min-h-screen w-full" style={{
    fontFamily: 'Inter, sans-serif'
  }} data-id="element-0">
      <HomePage data-id="element-1" />
    </div>;
}